var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"justify-space-between"},[_vm._t("default"),_c('v-btn',{staticClass:"mx-2",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v(" mdi-close ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }